export const demoPtBR = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': 'Jogue Agora — Adentre o Grymwyrd',
  'demo.seoDescription':
    'Gire o mundo, reclame um assento à mesa, forje um herói do Grymwyrd, e lance os ossos — um tour guiado pela mesa de realidade virtual do Grymwyrd.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'O mundo do Grymwyrd',
  'demo.globe.spinningWorld': 'Girando o mundo…',
  'demo.globe.tagline': 'Um mundo de horror-fantasia vivente',
  'demo.globe.arrivedHeading': 'Região de Greywick',
  'demo.globe.heading': 'Encontre seu lugar no crepúsculo eterno',
  'demo.globe.subheading': 'Uma mesa aguarda no coração do mundo. Tome seu assento e forje um herói.',
  'demo.globe.enterCta': 'Desça ao Grymwyrd',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': 'Torne-se parte da história',
  'demo.account.subheading':
    'Crie uma conta gratuita para desbloquear a enciclopédia completa do Grymwyrd e salvar o herói que você está prestes a forjar — ou passe como convidado e explore agora.',
  'demo.account.createAccount': 'Criar uma conta',
  'demo.account.logIn': 'Entrar',
  'demo.account.continueAsGuest': 'Continuar como convidado',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability} (3d6)',
  'demo.create.initiativeLabel': 'Iniciativa',
  'demo.create.lobbyEyebrow': 'Mesa Virtual Grymwyrd · Saguão',
  'demo.create.heading': 'Forje seu herói',
  'demo.create.subheading': 'Um personagem SRD 5.2.1, nascido do Grymwyrd. Nomeie-o, escolha um ofício, e lance os ossos.',
  'demo.create.nameLabel': 'Nome',
  'demo.create.namePlaceholder': 'Em quem se tornam?',
  'demo.create.chooseCalling': 'Escolha seu ofício',
  'demo.create.keyAbility': 'Principal: {ability}',
  'demo.create.abilityScores': 'Atributos',
  'demo.create.abilityScoresHint': '— clique para lançar 3d6',
  'demo.create.rollAbilityAria': 'Lançar {ability} (3d6)',
  'demo.create.keepStandard': 'Ou mantenha os 10s padrão e mergulhe.',
  'demo.create.initiativeResult': 'Iniciativa {initiative} — lance os ossos, a mesa se vira para você…',
  'demo.create.bonesTumble': 'Os ossos caem…',
  'demo.create.rollInitiativeCta': 'Lance pela iniciativa & tome seu assento',
  'demo.create.chooseCallingHint': 'Escolha um ofício para tomar seu assento.',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': 'A mesa não pôde ser armada',
  'demo.table.errorBody': 'A mesa de realidade virtual está indisponível no momento.',
  'demo.table.browseLiveTables': 'Procure mesas ao vivo em vez disso',
  'demo.table.settingTable': 'Armando sua mesa…',
  'demo.table.connecting': 'Conectando à mesa de realidade virtual…',
  'demo.table.heroTable': 'Mesa de {name}',
  'demo.table.firstTable': 'Sua primeira mesa',
  'demo.table.diceTrayHeading': 'Bandeja de dados',
  'demo.table.initiativeHeading': 'Iniciativa',
  'demo.table.initiativePrompt': 'Lance os ossos para definir a ordem de batalha.',
  'demo.table.rollForInitiative': 'Lance pela iniciativa',
  'demo.table.vttEyebrow': 'Grymwyrd VTT',
  'demo.table.xcardTitle': 'Pause o jogo, anonimamente',
  'demo.table.xcard': 'Cartão-X',
  'demo.table.saveHeroTitle': 'Crie uma conta gratuita para salvar seu herói',
  'demo.table.saveHero': 'Salvar herói',
  'demo.table.statusLive': 'Ao vivo',
  'demo.table.statusConnecting': 'Conectando',
  'demo.table.actionLogHeading': 'Registro de ações',
  'demo.table.recentRollsHeading': 'Lançamentos recentes',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': 'Ficha do Herói',
  'demo.panel.companion': 'Companheiro',
  'demo.panel.diceTray': 'Bandeja de Dados',
  'demo.panel.macros': 'Macros',
  'demo.panel.diceConsole': 'Console de Dados',
  'demo.panel.initiative': 'Iniciativa',
  'demo.panel.poll': 'Votação',
  'demo.panel.recentRolls': 'Lançamentos Recentes',
  'demo.panel.reference': 'Referência',
  'demo.panel.chat': 'Bate-papo',
  'demo.panel.handouts': 'Cópias',
  'demo.panel.safety': 'Segurança',
  'demo.panel.sceneAndCues': 'Cena & Deixas',
  'demo.panel.replay': 'Revisão',
  'demo.panel.recap': 'Resumo',
  'demo.panel.actionLog': 'Registro de Ações',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': 'Combate',
  'demo.action.cast': 'Lançar',
  'demo.action.move': 'Mover',
  'demo.action.block': 'Bloquear',
  'demo.action.chooseTarget': 'Escolha um alvo para {action}…',
  'demo.action.controlling': 'Controlando:',
  'demo.action.cannotAct': '{label} não consegue agir — selecione uma turba, jogador, veículo ou PNJ.',
  'demo.action.selectActionable': 'Selecione um objeto acionável para agir com ele.',
  'demo.action.cancel': 'Cancelar',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': 'Rolando a ordem…',
  'demo.tracker.combatant': 'Combatente {n}',
  'demo.tracker.previousTurn': 'Turno anterior',
  'demo.tracker.round': 'Rodada {round}',
  'demo.tracker.endCombatTitle': 'Encerrar combate',
  'demo.tracker.end': 'Encerrar',
  'demo.tracker.nextTurnTitle': 'Próximo turno',
  'demo.tracker.next': 'Próximo',
  'demo.tracker.hitPoints': 'Pontos de vida',
  'demo.tracker.reduceHp': 'Reduzir PV de {name}',
  'demo.tracker.raiseHp': 'Aumentar PV de {name}',
  'demo.tracker.addStatusEffect': 'Adicionar um efeito de status',
  'demo.tracker.removeFromOrder': 'Remover da ordem',
  'demo.tracker.removeFromOrderTitle': 'Remover da ordem',
  'demo.tracker.removeCondition': 'Remover {name}',
  'demo.tracker.roundsShort': '{n}r',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': 'A mesa está pausada',
  'demo.xcard.heading': 'A mesa está pausada',
  'demo.xcard.body':
    'Alguém levantou o Cartão-X. Fazemos uma pausa, sem perguntas e sem ninguém ser nomeado. Quando todos estiverem prontos, continue.',
  'demo.xcard.resume': 'Estamos prontos — continue',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': 'Cópias',
  'demo.handouts.titlePlaceholder': 'Título (opcional)',
  'demo.handouts.bodyPlaceholder': 'Uma nota, uma pista, um trecho para ler…',
  'demo.handouts.push': 'Enviar à mesa',
  'demo.handouts.whispered': 'Sussurrado',
  'demo.handouts.dismiss': 'Descartar cópia',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': 'Segurança',
  'demo.safety.description': 'Linhas que não cruzamos; véus que fechamos. Compartilhado por toda a mesa, nunca atribuído.',
  'demo.safety.linesLabel': 'Linhas (não absoluto)',
  'demo.safety.veilsLabel': 'Véus (cortar cena)',
  'demo.safety.removeItem': 'Remover "{item}"',
  'demo.safety.addLinePlaceholder': 'Adicione uma linha…',
  'demo.safety.addVeilPlaceholder': 'Adicione um véu…',
  'demo.safety.addLine': 'Adicionar linha',
  'demo.safety.addVeil': 'Adicionar véu',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': 'Ficha do Herói',
  'demo.sheet.hp': 'PV',
  'demo.sheet.ac': 'CA',
  'demo.sheet.classLevel': '{className} · Nv 1',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': 'Dispositivo companheiro',
  'demo.companion.description':
    'Emparelhe um telefone ou tablet como uma segunda tela somente leitura — iniciativa, lançamentos recentes e a cena espelham no dispositivo. Revogar a qualquer momento.',
  'demo.companion.pairDevice': 'Emparelhar um dispositivo',
  'demo.companion.qrAriaLabel': 'Código QR de emparelhamento do companheiro',
  'demo.companion.copied': 'Copiado',
  'demo.companion.copyLink': 'Copiar link',
  'demo.companion.revoke': 'Revogar',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': 'Macros de Dados',
  'demo.macros.dismissError': 'Descartar erro',
  'demo.macros.newMacro': 'Nova macro',
  'demo.macros.namePlaceholder': 'Nome (sem pontos)',
  'demo.macros.labelPlaceholder': 'Rótulo de botão (opcional)',
  'demo.macros.save': 'Salvar macro',
  'demo.macros.noDots': 'Nomes de macros não podem conter pontos.',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': 'Votação',
  'demo.poll.questionPlaceholder': 'Pergunte à mesa…',
  'demo.poll.optionPlaceholder': 'Opção {n}',
  'demo.poll.removeOption': 'Remover opção {n}',
  'demo.poll.addOption': 'Adicionar opção',
  'demo.poll.openPoll': 'Abrir votação',
  'demo.poll.live': 'Ao vivo',
  'demo.poll.closed': 'Votação fechada',
  'demo.poll.vote': 'Votar',
  'demo.poll.closePoll': 'Fechar votação',
  'demo.poll.startNewPoll': 'Iniciar uma nova votação',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': 'Resumo da sessão',
  'demo.recap.tagline': 'A história de sua mesa, quando a poeira assenta.',
  'demo.recap.gathering': 'Reunindo a história…',
  'demo.recap.getRecap': 'Obter o resumo da sessão',
  'demo.recap.notableRolls': 'Lançamentos notáveis',
  'demo.recap.copied': 'Copiado!',
  'demo.recap.share': 'Compartilhar',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': 'Referência',
  'demo.reference.searchPlaceholder': 'Procure um monstro, feitiço, regra…',
  'demo.reference.searchAria': 'Procure a enciclopédia para compartilhar',
  'demo.reference.typeToSearch': 'Digite pelo menos duas letras para procurar a enciclopédia vivente.',
  'demo.reference.searching': 'Procurando…',
  'demo.reference.open': 'Abrir {title}',
  'demo.reference.share': 'Compartilhar',
  'demo.reference.dismiss': 'Descartar referência',
  'demo.reference.backToSearch': 'Voltar à pesquisa',
  'demo.reference.loadingContent': 'Carregando conteúdo…',
  'demo.reference.notOwned':
    'Você ainda não possui este livro. A referência completa se desbloqueia ao adicioná-lo à sua biblioteca.',
  'demo.reference.contentDown': 'O conteúdo está indisponível agora. Tente novamente em um momento.',
  'demo.reference.noAdditionalContent': 'Sem conteúdo adicional para esta referência.',
  'demo.reference.noLinkedContent': 'Sem conteúdo de livro vinculado para esta referência.',
  'demo.reference.shareToTable': 'Compartilhar à mesa',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': 'Revisão',
  'demo.replay.tagline': 'Volte pela sessão batida por batida.',
  'demo.replay.loading': 'Carregando…',
  'demo.replay.loadReplay': 'Carregar revisão',
  'demo.replay.loadMore': 'Carregar mais',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': 'Dados',
  'demo.dice.dismissError': 'Descartar erro',
  'demo.dice.labelPlaceholder': 'Ataque (opcional)',
  'demo.dice.roll': 'Lançar',
  'demo.dice.rolledForReal': 'Lancei de verdade',
  'demo.dice.totalPlaceholder': 'Total (obrigatório)',
  'demo.dice.physNotationPlaceholder': '1d20+5 (opcional)',
  'demo.dice.physLabelPlaceholder': 'Rótulo (opcional)',
  'demo.dice.logPhysical': 'Registrar lançamento físico',
  'demo.dice.onTable': '🎲 na-mesa',
  'demo.dice.private': 'Privado',
  'demo.dice.public': 'Público',
  'demo.dice.rolledPrivately': 'lançado em privado',
  'demo.dice.exploded': 'explorado',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': 'Cena & deixas',
  'demo.scene.current': 'Cena: {scene}',
  'demo.scene.cueSuffix': '— deixa: {cue}',
  'demo.scene.noScene': 'Nenhuma cena definida',
  'demo.scene.oneShotCues': 'Deixas pontuais',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} em {x},{y}',
  'demo.map.tile': 'Célula {x},{y}',
  'demo.map.fogged': 'Enevoado',
  'demo.map.battleMap': 'Mapa de batalha',
  'demo.map.gm': 'Mestre',
  'demo.map.noMap': 'Nenhum mapa',
  'demo.map.uploadedMap': 'Mapa enviado',
  'demo.map.uploadTitle': 'Envie uma imagem de mapa como fundo da tela',
  'demo.map.reading': 'Lendo…',
  'demo.map.upload': 'Enviar',
  'demo.map.size': 'Tamanho',
  'demo.map.shrinkMap': 'Encolher mapa',
  'demo.map.growMap': 'Aumentar mapa',
  'demo.map.widthShort': 'L',
  'demo.map.narrowMap': 'Estreitar mapa',
  'demo.map.widenMap': 'Alargar mapa',
  'demo.map.heightShort': 'A',
  'demo.map.shortenMap': 'Encurtar mapa',
  'demo.map.heightenMap': 'Alongar mapa',
  'demo.map.fitTitle': 'Redefinir posição + esticar para preencher a grade',
  'demo.map.fit': 'Ajustar',
  'demo.map.lock': 'Bloquear',
  'demo.map.adjust': 'Ajustar',
  'demo.map.fogOn': 'Enevoamento ATIVADO — clique para desativar',
  'demo.map.fogOff': 'Enevoamento DESATIVADO — clique para ativar',
  'demo.map.fog': 'Enevoamento',
  'demo.map.exitPaintTitle': 'Sair do modo de pintura',
  'demo.map.paintTitle': 'Pintar enevoamento — clique ou arraste células para revelar/ocultar',
  'demo.map.exitPaint': 'Sair pintura',
  'demo.map.paint': 'Pintura',
  'demo.map.hexGridTitle': 'Grade hexagonal — clique para quadrado',
  'demo.map.squareGridTitle': 'Grade quadrada — clique para hexagonal',
  'demo.map.hex': 'Hexagonal',
  'demo.map.zoomOut': 'Afastar',
  'demo.map.zoomLevel': 'Nível de zoom',
  'demo.map.zoomIn': 'Aproximar',
  'demo.map.resetView': 'Redefinir visualização',
  'demo.map.reset': 'Redefinir',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': 'Expandir {title}',
  'demo.dock.collapse': 'Recolher {title}',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': 'Sair da mesa?',
  'demo.leave.heading': 'Sair da mesa?',
  'demo.leave.body':
    'Você está no meio de um jogo. Esta é uma mesa de convidado — se sair agora, a sessão termina e seu herói se perde.',
  'demo.leave.stay': 'Permanecer na mesa',
  'demo.leave.leaveAnyway': 'Sair mesmo assim',
}
